import React from 'react'
import { useNavigate } from 'react-router-dom'
import Footer from './Footer'
import Navbar from './Navbar'
import gym5 from '../Images/gym5.jpg'


const About = () => {
  const navigate = useNavigate()
  const handlefunc=()=>{
    navigate("/contact")
  }


  return (
    <>
  <Navbar/>
    <section className='about-main'>
      <div className="about">
        <div className='in'>
          <h1 className='head'>HUM FITNESS</h1>
          <p>he Company(s) shall maintain one (1) website to be called “Original Soup Man”, for the sale of soup products only, together with sales information for Franchise to be licensed for the retail sale of such soups and other product manufactured or distributed by the Company pursuant to the Agreement between the Parties. It is agreed that the Parties shall initially agree upon the content of the website on or before January 31, 2005 with time being of the essence, and that all subsequent changes and/or additions must be approved by the Company AI Y. The cost of the organizations, production and maintenance of this web site shall be borne by the Company, www.therealsoupman.com and AY shall maintain his existing website at this own expense.</p>
        </div>
        <img src={gym5} className="about-img img-fluid"/>
      </div>
        <button onClick={handlefunc}>Contact</button>
    </section>
    <Footer/>
    </>
  )
}

export default About